import React from "react"
import "./HandrulesEntry.css"
import requestHandler from "../../../utils/requestHandler";
import config from "../../../config";
import pointing from "../../../assets/icons/pointing.svg"
import { useApi } from "../../../hooks/useApi";
const HandrulesEntry = ({ type, name, no }) => {
	const { api } = useApi();
	return (
		<div className="entryContainer">
			<div className="ruleType">{type[0]}</div>
			<div className="ruleUser">{name}</div>
			{no !== undefined ? (<div className="ruleNo" onClick={() => api(`handrules/${config.handrulesLobbyId}/${no}`, 'DELETE')}>
				<img src={pointing} alt="pointing" />
			</div>) : (<div></div>)}
		</div>
	)
}
export default HandrulesEntry;